/** 无 pool 信息时的回退 */
const DEFAULT_ROLE_LABELS: Record<string, string> = {
  SELF: '自评',
  DIRECT: '直属领导',
  DIAGONAL: '斜线领导/带教老师',
  SAME_DEPT: '本部门同事',
  CROSS_DEPT: '跨部门同事',
  SUBORDINATE: '下属',
  PEER_LEADER: '同级同事',
  OTHER_LEADER: '其他领导',
};

/**
 * Legacy 池内称呼（字典未加载 / 无匹配 code 时 fallback）。
 * 管理端请优先用 useEvalRoleLabels().getEvalRoleLabel。
 */
export function getEvalRoleLabelLegacy(
  templatePool: string | undefined,
  role: string | null | undefined,
): string {
  if (!role) return '-';
  const p = templatePool || '';

  if (p === 'EXECUTIVE') {
    const map: Record<string, string> = {
      SELF: '自评',
      DIRECT: '直属领导',
      DIAGONAL: '斜线领导/带教老师',
      OTHER_LEADER: '其他领导',
      SUBORDINATE: '其他领导/下属',
      SAME_DEPT: '本部门同事',
      CROSS_DEPT: '跨部门同事',
      PEER_LEADER: '同级同事',
    };
    return map[role] || role;
  }

  if (p === 'MIDDLE_MGMT') {
    const map: Record<string, string> = {
      SELF: '自评',
      DIRECT: '直属领导',
      DIAGONAL: '斜线领导/带教老师',
      SUBORDINATE: '下属',
      PEER_LEADER: '同级同事',
      OTHER_LEADER: '其他领导',
      SAME_DEPT: '本部门同事',
      CROSS_DEPT: '跨部门同事',
    };
    return map[role] || role;
  }

  // 销售 / 医护 / 综合职能 / 财务数据 / 营销获客
  if (
    p === 'SALES' ||
    p === 'MEDICAL_OPS' ||
    p === 'BACKEND' ||
    p === 'FINANCE_DATA' ||
    p === 'MARKETING_ACQUISITION'
  ) {
    const map: Record<string, string> = {
      SELF: '自评',
      DIRECT: '直属领导',
      DIAGONAL: '斜线领导/带教老师',
      SAME_DEPT: '本部门同事',
      CROSS_DEPT: '跨部门同事',
      SUBORDINATE: '下属',
      PEER_LEADER: '同级同事',
      OTHER_LEADER: '其他领导',
    };
    return map[role] || role;
  }

  return DEFAULT_ROLE_LABELS[role] || role;
}

/** @deprecated 请用 useEvalRoleLabels().getEvalRoleLabel */
export function getEvalRoleLabel(
  templatePool: string | undefined,
  role: string | null | undefined,
): string {
  return getEvalRoleLabelLegacy(templatePool, role);
}
